import React, { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { BadgeCheck } from "lucide-react";

// Opt in to show approved campaign posts in the public customer showcase on the landing page.
export const ShowcaseToggle = () => {
  const { user, checkAuth } = useAuth();
  const [on, setOn] = useState(!!user?.showcase_opt_in);
  const [busy, setBusy] = useState(false);
  const change = async (v) => {
    setBusy(true); setOn(v);
    try {
      await api.put("/auth/showcase", { opt_in: v });
      toast.success(v ? "Your approved posts can now appear in the showcase" : "Removed from the showcase");
      checkAuth && checkAuth();
    } catch (e) { setOn(!v); toast.error("Could not update the setting"); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-lg border border-border bg-secondary/20 p-4 flex items-start justify-between gap-4" data-testid="showcase-toggle-card">
      <div>
        <p className="text-sm font-semibold flex items-center gap-2"><BadgeCheck className="h-4 w-4 text-emerald-400" /> Feature my posts</p>
        <p className="text-xs text-muted-foreground mt-1 max-w-md">Show up to 2 of your scheduled or published campaign posts (with your brand name) in the public gallery on our homepage. Turn off anytime.</p>
      </div>
      <Switch checked={on} disabled={busy} onCheckedChange={change} data-testid="showcase-toggle" className="data-[state=unchecked]:bg-muted-foreground/40 shrink-0" />
    </div>
  );
};
